import { Injectable } from '@angular/core';
import { enc, HmacSHA256 } from "crypto-js";
import { v4 as uuidv4 } from 'uuid';
import {environment} from '../../../environments/environment';

export type RequestMethod = 'GET' | 'POST' | 'PATCH' | 'DELETE' | 'PUT';

@Injectable({
  providedIn: 'root',
})

export class HmacService {
  generateToken(url: string, method: RequestMethod, body: unknown) {
    const clientId = environment.clientId;
    const clientSecret = environment.clientSecret;

    const timeStamp = Math.floor(new Date().getTime() / 1000);
    const nonce = uuidv4().replace(/-/g, '');
    const reqUrl = encodeURIComponent(url).toLowerCase();

    let requestContentBase64String = '';
    if (method !== 'GET' && body) {
      requestContentBase64String = this.getHmacBase64(JSON.stringify(body), clientSecret);
    }

    const signatureRawData = `${clientId}${method}${reqUrl}${nonce}${timeStamp}${requestContentBase64String}`;
    const requestSignatureBase64String = this.getHmacBase64(signatureRawData, clientSecret);

    return `amx ${clientId}:${requestSignatureBase64String}:${nonce}:${timeStamp}`
  }

  private getHmacBase64(str: string, secret: string) {
    const hmacStr = HmacSHA256(str, secret);
    return enc.Base64.stringify(hmacStr);
  }

}
